define([
    'common/ui/view/svg/util',
    'victor',
    'backbone',
    'backbone.marionette',
    'd3'
], function(
    SVGUtil,
    Victor,
    Backbone,
    Mn,
    d3
    ) {
    // d3 の append を拡張して jQuery の append のように使えるようにうする
    var _append = d3.selection.prototype.append;
    d3.selection.prototype.append = function(arg) {
        // 引数が d3.selection の場合は appendChild を使って append する
        if(arg instanceof d3.selection) {
            var node = this.node();
            var childNode = arg.node();
            node.appendChild(childNode);
            arg.parent = this;

            return d3.select(childNode);
        }

        if (arg instanceof SVGElement) {
            var node = this.node();
            var childNode = arg;
            node.appendChild(childNode);
            arg.parent = this;

            return d3.select(childNode);
        }

        if (arg instanceof DocumentFragment) {
            var node = this.node();
            var childNode = arg;
            node.appendChild(childNode);
            arg.parent = this;

            return d3.select(childNode);
        }

        if (typeof arg === 'function') {
            _.each(this[0], function(node) {
                if(!node) {
                    return
                }
                var data = node.__data__;
                var childNode = arg.call(node, data);
                d3.select(node).append(childNode);
                d3.select(childNode).datum(data);
            });

            return d3.select(childNode);
        }

        return _append.call(this, arg);
    };

    // enter の append も拡張する
    var __append = d3.selection.prototype.enter.prototype.append;
    d3.selection.prototype.enter.prototype.append = function(arg) {
        // 引数が function の場合は data を渡して function を call
        if (typeof arg === 'function') {
            var self = this[0].parentNode;
            _.each(this[0], function(node) {
                if(!node) {
                    return
                }
                var data = node.__data__;
                var childNode = arg.call(self, data);
                d3.select(self).append(childNode);
                d3.select(childNode).datum(data);
            });

            return;
        }

        return __append.call(this, arg);
    };

    /**
     * @exports balus/views/diagram/svg-view
     */
    var SVGView = Backbone.Marionette.View.extend(
        /**
         * @lends module:balus/views/diagram/svg-view.SVGView.prototype
         */
        {
            tagName: 'g',
            className: null,
            draggable: false,
            template: false,
            minDragLength: 32,

            /**
             * d3 の selection を backbone の View のように扱うための View。
             *
             * d3 は宣言的な言語であり、ある View がレンダリングしたノードを、
             * 上位のノードに append する、といった使い方はできない。
             * そのままだと、Backbone と組み合わせた際に HTML 側の View と
             * 使い方が異なり分かりづらいため合わせられるようにした。
             * そのために d3 側にも若干変更を加えている。
             *
             * SVGView を利用すると以下のような書き方ができるようになる。
             * @example
             * var view = new SVGView();
             * d3.select('#hoge')
             *     .append(view.render().el);
             *
             * @constructs
             * @param params
             */
            initialize: function(params) {
                _.bindAll(this, '_onDrag', '_onDragEnd', '_onClick',
                    '_onDragStart', '_onDoubleClick');
                this.params = params;
                var className = params.className ? params.className : this.className;
                this.$el = d3.select(document.createElementNS(
                    "http://www.w3.org/2000/svg", this.tagName));
                if(className) {
                    this.$el.classed(this.getClassName(className), true)
                }
                this.el = this.$el.node();
                const draggable = this.getOption('draggable');
                if(_.isFunction(draggable)) {
                    this.draggable = _.bind(draggable, this)();
                } else {
                    this.draggable = draggable;
                }
            },

            getClassName: function(className) {
                if(_.isFunction(className)) {
                    return _.bind(className, this)();
                } else {
                    return className;
                }
            },

            onRender: function() {
                this.$el
                    .on('mousedown', this.stopEvent)
                    .on('touchstart', this.stopEvent);

                if(this.draggable) {
                    var drag = d3.drag()
                        .on('drag', this._onDrag)
                        .on('start', this._onDragStart)
                        .on('end', this._onDragEnd);
                    this.$el.call(drag);
                } else {
                    this.$el.on('click', this._onClick);
                }
                this.$el.on('dblclick', this._onDoubleClick);
                return this;
            },

            onClick: function(pos) {},
            _onClick: function() {
                var pos = Victor.fromObject(
                    SVGUtil.getEventPos());
                this.onClick(pos, {dragging: false});
            },

            onDoubleClick: function(pos) {},
            _onDoubleClick: function() {
                var pos = Victor.fromObject(
                    SVGUtil.getEventPos());
                this.onDoubleClick(pos);
            },

            onDrag: function(pos, dpos) {},
            _onDrag: function() {
                this.onDrag(
                    Victor.fromObject(SVGUtil.getEventPos()),
                    Victor(d3.event.dx, d3.event.dy)
                )
            },

            _onDragStart: function() {
                this.dragStartPos = Victor.fromObject(
                    SVGUtil.getEventPos());
                console.log('dragstart');
            },

            onDragEnd: function(pos) {},
            _onDragEnd: function() {
                console.log('dragend');
                var pos = Victor.fromObject(
                    SVGUtil.getEventPos());
                var d = 0;
                if(this.dragStartPos) {
                    d = this.dragStartPos.clone().subtract(pos).length();
                    this.dragStartPos = null;
                }
                if(d < this.getOption('minDragLength')) {
                    this.onClick(pos, {dragging: true});
                } else {
                    this.onDragEnd(pos);
                }
            },

            stopEvent: function() {
                d3.event.stopPropagation();
            },

            remove: function(){
                SVGView.__super__.remove.call(this);
                this.$el.remove();
            },

            transform: function(d) {
                this.$el.attr('transform', SVGUtil.transform(d));
            },

            updateStyles: function(styles) {
                _.each(styles, _.bind(function(v, k) {
                    this.$el.style(k, v);
                }, this));
            },

            updateAttrs: function(attrs) {
                _.each(attrs, _.bind(function(v, k) {
                    this.$el.attr(k, v);
                }, this));
            },

            setImage: function(image_id) {
                if(!image_id) {
                    this.$el.style('fill', null)
                }

                this.$el.style('fill',
                    'url(#' + image_id + ')');
            }
        });

    return SVGView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/index.js